import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { FieldContext } from "./FieldContext";
export var EmbeddedFieldContext =
/*#__PURE__*/
function (_FieldContext) {
  _inherits(EmbeddedFieldContext, _FieldContext);

  function EmbeddedFieldContext() {
    _classCallCheck(this, EmbeddedFieldContext);

    return _possibleConstructorReturn(this, _getPrototypeOf(EmbeddedFieldContext).apply(this, arguments));
  }

  _createClass(EmbeddedFieldContext, [{
    key: "getAggregationPath",
    value: function getAggregationPath() {
      return undefined;
    }
  }, {
    key: "wrapAggregations",
    value: function wrapAggregations() {
      for (var _len = arguments.length, aggregations = new Array(_len), _key = 0; _key < _len; _key++) {
        aggregations[_key] = arguments[_key];
      }

      return aggregations;
    }
  }, {
    key: "wrapFilter",
    value: function wrapFilter(filter) {
      return filter;
    }
  }]);

  return EmbeddedFieldContext;
}(FieldContext);